const doc = [({"da":({"js":({"admin":({"economy":({"dimensions":({"dimensions":"Dimensioner"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;